import * as types from "../constants/ActionTypes";

const initialState = {
    username: ""
}

export default function usernameOfResetPasswordReducer(state = initialState, action) {
    if (action.type === types.SET_USERNAME_OF_RESET_PASSWORD) {
        return { username: action.data }
    }
    
    return state;
}